module.exports = __webpack_public_path__ + "img/textarea.9515f27e.svg";